class RevealOnScroll extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    this.revealWrapper = this.querySelector('.reveal-content');
    this.contentTotal = this.querySelectorAll('.reveal-content__content').length;
    this.revealWrapperHeight = this.contentTotal * 100;
    this.revealWrapper.style.setProperty('--reveal-wrapper-height', `${this.revealWrapperHeight}svh`);

    window.addEventListener('scroll', this.handleScroll);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const revealWrapperTop = this.revealWrapper.getBoundingClientRect().top + window.scrollY;
    const scrollY = Math.max(window.scrollY - revealWrapperTop, 0);
    const sectionHeight = this.revealWrapper.offsetHeight;
    const clipAmount = Math.min(scrollY / sectionHeight * this.revealWrapperHeight, 200);

    /* MIDDLE DIV */
    const middleDiv = this.querySelector('.reveal-content__content.middle');
    if (middleDiv) {
      const topSecondItemClip = Math.max(100 - clipAmount, 0);
      middleDiv.style.setProperty('--clipInsetTopSecondItem', `${topSecondItemClip}svh`);

      if (topSecondItemClip === 0 && clipAmount <= 200) {
        const bottomClipAmount = -30 + ((clipAmount - 100) / 100 * 130);
        middleDiv.style.setProperty('--clipInsetBottomSecondItem', `${bottomClipAmount}svh`);
      }
    }

    /* LAST DIV */
    const lastDiv = this.querySelector('.reveal-content__content.last');
    const lastClipAmount = Math.max(100 - clipAmount, 0);
    lastDiv.style.setProperty('--clipInsetLastItem', `${lastClipAmount}svh`);
  }
}

customElements.define('reveal-on-scroll', RevealOnScroll);
